const parseCSVLine = (line: string): string[] => {
  const values: string[] = [];
  let current = '';
  let insideQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (char === '"') {
      insideQuotes = !insideQuotes;
    } else if (char === ',' && !insideQuotes) {
      values.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  values.push(current.trim());

  return values;
};

export const parseCSVOneOnOne = (csvString: string): Record<string, string>[] => {
  const lines = csvString.split('\n');
  const headers = lines[0].split(',');
  const result: Record<string, string>[] = [];

  for (let i = 1; i < lines.length; i++) {
    const values = parseCSVLine(lines[i]);

    const entry: Record<string, string> = {};
    for (let j = 0; j < headers.length; j++) {
      entry[headers[j]] = values[j];
    }
    result.push(entry);
  }
  return result;
};

export const convertToCSVOneOnOne = (arr: any[]): string => {
  const csvRows: string[] = [];

  // Add headers
  const headers = Object.keys(arr[0] ?? []);
  csvRows.push(headers.join(','));

  // Add data rows
  for (const row of arr) {
    const values = headers.map((header) => {
      const rawValue = (row as Record<string, any>)[header];
      // If the raw value contains a comma, enclose it in double quotes
      const formattedValue = rawValue.includes(',') ? `"${rawValue}"` : rawValue;
      return formattedValue;
    });
    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};
